import { inject, injectable } from "tsyringe";
import { ExtensionContext } from "../common/models/extension-config";
import { Module } from "../common/module";
import { CommonModule } from "./common.module";

@injectable()
export class EnrichedContextModule extends Module {

    constructor(@inject(CommonModule) private common: CommonModule) {
        super([common]);
    }

    public name: string = 'EnrichedContextModule';
    public acceptedLicenseFlags: string[] = [];
    public shouldRun(context: ExtensionContext): boolean { return context == ExtensionContext.vizportal; }
    public async run(): Promise<void> {
        window.addEventListener('message', event => {
            if (!event || event.type !== 'message') {
                return;
            }
            // if the message is the response we were looking for from vizportal
            if (event.data && event.data.type === 'ElementsEnrichedContextRequest') {
                event.source?.postMessage({
                    type: 'ElementsEnrichedContextResponse',
                    data: {
                        workbookName: this.getWorkbookName(),
                        dashhboardUrl: window.location.href
                    }
                });

            }
        }, false);
    }
    getWorkbookName() {
        var t = window.tableau;
        if (!t) {
            return null;
        }
        var v = window.tableau.VizManager;
        if (!v) {
            return null;
        }
        var vizs = window.tableau.VizManager.getVizs();
        if (!vizs) {
            return null;
        }
        var viz = vizs[0];
        if (!viz) {
            return null;
        }
        var wb = viz.getWorkbook();
        if (!wb) {
            return null;
        }
        return wb.getName();

    }




}